<template>
  <div class="notfind">
    <div class="kada-container">
      <div class="body">
        <div class="left">
          <p>哎呀！您访问的页面走丢了，请过一会儿再来试吧！</p>
          <div class="middle">
            <img src="@/assets/img/404.png" alt />
          </div>
          <div class="back">
            <button @click="back()">返回首页</button>
          </div>
        </div>
        <div class="right">
          <img src="@/assets/img/boat.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    back() {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/404.vue